import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  Z_INDEXS
} from '../../themes'

export const StyleSidebar = styled.div`
    z-index: ${Z_INDEXS.LV_8};
    flex: 0;
    h1 {
        font-family: LibreBaskervilleBold;
        font-size: ${FONT_SIZE.MD};
        margin: 0;
    }
    hr {
      width: 80%;
      border: 1px solid ${COLOR.GRAY_3};
      z-index: ${Z_INDEXS.LV_1};
      margin-top: 0px;
      margin-bottom: 0px;
    }
    .body {
      height: 100%;
      width: 260px;
      border-right: 1px solid ${COLOR.GRAY_5};
      background-color: #FFFFFF;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
    }

    .body-top {
      display: flex;
      flex-direction: column;
    }

    .body-bottom {
      position: absolute;
      bottom: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .header-title {
        display: flex;
        justify-content: left;
        align-items: center;
        padding: 8px 24px;
        margin-bottom: 16px;
        border-bottom: 1px solid ${COLOR.GRAY_5};
        img {
            margin: auto;
            width: auto;
            height: 64px;
            max-width: 100%;
            object-fit: contain;
        }
    }
    .header-text {
        padding: 0px 24px;
        padding-top: 10px;
        font-family: LibreBaskervilleBold;
        margin-bottom: 24px;
    }
    .small-calendar {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 8px auto;
        width: 100%;
        box-sizing: border-box;
        transform: scale(0.95);
        transform-origin: center;
    }
    .menu {
        overflow: auto;
        padding: 24px 0px;
        flex: 0.5;
        // overflow: scroll;
        ::-webkit-scrollbar {
            -webkit-appearance: none;
            width: 3px;
        }
        ::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background-color: rgba(0,0,0,.2);
            -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
        }
    }
    .profile {
        background-color: white;
        width: calc(100% - 32px);
        margin: 8px 16px;
        display: flex;
        padding: 12px;
        border: 1px solid #D4D4D4;
        border-radius: 10px;
        box-sizing: border-box;
        bottom: 0;
        justify-content: space-between;
        align-items: center;
        flex: 0;
    }
    .profile-email {
        font-family: NunitoSansRegular, sans-serif;
        font-size: 14px;
        font-weight: 400;
        color: ${COLOR.BLACK_5};
        flex: 1;
        margin: 0 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .avatar-placeholder {
        width: 32px;
        height: 32px;
        min-width: 32px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 12px;
        font-weight: 700;
        font-family: NunitoSansBold, sans-serif;
    }
    .profile #text {
        text-align: left;
        font-family: NunitoSansRegular;
    }
    .sub-menu {
      line-height: 36px;
    }
    .text-bar {
        font-family: NunitoSansRegular;
        font-size: ${FONT_SIZE.XXS};
        padding-left: 24px;
    }
    .text-bar-inative {
        font-family: NunitoSansRegular;
        font-size: ${FONT_SIZE.XXS};
        padding-left: 24px;
        color: ${COLOR.GRAY_15};
    }
    .avatar {
        width: 32px;
        height: 32px;
        min-width: 32px;
        border-radius: 50%;
    }
    .border-bar, .active-border-bar {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        float: left;
        height: 30px;
        border-width: 2.6px;
        border-style: solid;
        border-color: rgb(253, 253, 254);
        border-image: initial;
    }
    .active-border-bar {
        border-color: ${COLOR.GOLD_1};
        background: ${COLOR.GOLD_1};
    }
    .img-width {
        max-width: 100%;
        max-height: 100%;
    }

  .sidebar-menu-sections {
    max-height: 120px;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.XXS};
    line-height: 22px;

    > * {
      padding: 15px 25px;
      color: ${COLOR.GRAY_20};
      cursor: pointer;
    }
  }

  .sidebar-menu-btn {
    outline: 0;
    margin: 0;
    padding: 11px 0 10px;
    border: unset;
    background: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .sidebar-menu-ic-down {
    transform: rotate(180deg);
  }

  @media (min-height: 700px) {
    .sidebar-menu-sections {
      max-height: 374px;
    }
  }

  @media (min-height: 1000px) {
    .sidebar-menu-sections {
      max-height: unset;
    }
  }
`

